import React, { memo, useState, useCallback } from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import { Label } from "reactstrap";
import debounce from "lodash.debounce";
import { productsearchProduct } from "../../../services/Apis";

const CreatableDropdown = ({ label, readonly,setSelectedOption,selectedOption,clearProductDATA, setValues }) => {
    // Debounced API-based options loader using your existing API function
    const loadOptions = useCallback(
        debounce((inputValue, callback) => {
            if (!inputValue) {
                callback([]);
                return;
            }

            productsearchProduct(inputValue)
                .then((response) => {
                    if (response?.success) {
                        const options = response?.data?.map((item) => ({
                            value: item.productid,
                            label: item.title,
                        }));
                        callback(options);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching options:", error);
                    callback([]);
                });
        }, 500), [] // debounce delay of 500ms
    );

    const handleClearData = (inputValue) => {
        clearProductDATA()
        setValues((prevValues) => ({
            ...prevValues,
            title: inputValue,
            productid: 0,
            arabic_title: '',
            model_no: '',
            product_type: 1,
            categoryid: '',
            variant_group: '',
            weight: '',
            height: '',
            length: '',
            width: '',
            short_description: '',
            arabic_short_description: '',
            variant_group: '',
            variant_group_value: '',
            product_condition: 'New',
            video_link: '',
            variant_group_value: '',
            search_product: '',
            warranty_type:'',
            warranty:'',
            brandid: '',
            web_images: [],
            rstatus: 1,
            seo_title: '',
            seo_description: '',
            seo_keywords: ""
        }));
    }

    // Handle select or create value
    const handleChange = (newValue) => {
        if (newValue) {
            setSelectedOption(newValue);
            setValues((prevValues) => ({
                ...prevValues,
                title: newValue?.label,
                productid: newValue?.value,
            }));
        } else {
            handleClearData('')
            setSelectedOption(null)
        }
    };

    // Handle new option creation
    const handleCreateOption = (inputValue) => {
        const newOption = { value: 0, label: inputValue };
        setSelectedOption(newOption);
        handleClearData(inputValue)
    };

    // Custom styling
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '25px',       // Smaller height
            height: 'auto',
            flexWrap: 'wrap',
            fontSize: '0.875rem',    // Bootstrap's `sm` font size
            padding: '0 6px',
        }),
        valueContainer: (provided) => ({
            ...provided,
            // height: '30px',
            padding: '0 6px',
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',
            padding: 0,
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '25px',
        }),
        multiValue: (provided) => ({
            ...provided,
            fontSize: '0.75rem',
        }),
    };

    return (
        <div className="mb-3">
            {label && <Label className="form-label">{label}</Label>}
            <AsyncCreatableSelect
                cacheOptions
                defaultOptions
                loadOptions={loadOptions}
                onChange={handleChange}
                onCreateOption={handleCreateOption}
                value={selectedOption}
                placeholder="Type to search or create"
                isClearable
                isDisabled={readonly ? true : false}
                styles={customStyles}
            />
        </div>
    );
};

export default memo(CreatableDropdown);
